import React, { useEffect, useState } from "react";
import {
  useCreateMoistureDataMutation,
  useUpdateMoistureRoomDataMutation,
} from "./reworkApi";
import { useGetCartListQuery } from "../../processing/cooking/cookingApi";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment";
import { convertToUserTimezone, getCurrentDate, getCurrentDateTime } from "../../../helpers/Utils";
import { newIncreasingDate } from "../../../components/shared/utils";

const MoistureRoomModal = ({
  show,
  setShow,
  record,
  mode,
  type_name,
  date,
  lot_number_id,
}) => {
  const [createData] = useCreateMoistureDataMutation();
  const [updateData] = useUpdateMoistureRoomDataMutation();
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const shouldSelectType = mode === "add" && !type_name;


  const initialFormData = {
    created_at: currentDate,
    status: "",
    treys_count: "",
    time_end: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    time_entered: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    type: "",
    cart_number_id: "",
    cart_number: {},
    lot_number_id: lot_number_id,
    cheeks_kg_bagged: "",
    strips_kg_bagged: "",
    tapita_kg_bagged: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const { data: cartsList } = useGetCartListQuery({ status:"available" });

  useEffect(() => {
    if (mode === "edit" && record) {
      const updatedFormData = { ...initialFormData };

      for (const key in record) {
        if (key === "cart_number")
          updatedFormData["cart_number_id"] = record.cart_number.id;
        if (key in initialFormData) updatedFormData[key] = record[key];
      }
      updatedFormData.time_entered = record.time_entered
        ? convertToUserTimezone(record.time_entered, "YYYY-MM-DDTHH:mm")
        : "";
      updatedFormData.time_end = record.time_end
        ? convertToUserTimezone(record.time_end, "YYYY-MM-DDTHH:mm")
        : "";
      setFormData(updatedFormData);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, record, show]);

  const handleClose = () => {
    setShow(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const type = formData.type;
    const payload = {
      ...formData,
      cheeks_kg_bagged:
        type === "cheeks" || type === "cheeks/strips" || type === "cheeks/tapita"
          ? formData.cheeks_kg_bagged || 0
          : 0,
      strips_kg_bagged:
        type === "strips" || type === "cheeks/strips"
          ? formData.strips_kg_bagged || 0
          : 0,
      tapita_kg_bagged:
        type === "tapita" || type === "cheeks/tapita"
          ? formData.tapita_kg_bagged || 0
          : 0,
    };
    const mutation = mode === "add" ? createData : updateData;

    try {
      await mutation(
        mode === "add" ? payload : { id: record.id, requestBody: payload },
      ).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };
  const isCartAvailable = (cart) => {
    return cart.status === "available" || cart.id == record?.cart_number.id;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Auto-calculate time_end based on type and time_entered
    if ((name === "time_entered" && formData.type !== "") || name === "type") {
      const selectedType = name === "type" ? value : formData.type;
      const baseTime = name === "time_entered" ? value : formData.time_entered;

      const minutesMap = {
        "cheeks": 690,
        "strips": 570,
        "cheeks/strips": 570,
        "tapita": 690,
        "cheeks/tapita": 690,
      };

      const minutes = minutesMap[selectedType];
      if (minutes) {
        const expEndTime = newIncreasingDate(minutes, baseTime);
        setFormData((prev) => ({ ...prev, [name]: value, time_end: expEndTime }));
        return;
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("form_time_entered", "Time Entered")}
          type="datetime-local"
          name="time_entered"
          value={formData.time_entered}
          onChange={handleChange}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("batch_code", "Batch Code")}
          type="number"
          name="lot_number_id"
          value={formData.lot_number_id}
          onChange={handleChange}
          disabled={true}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("form_cart_number", "Carts Number")}
          type="number"
          name="cart_number_id"
          value={formData.cart_number_id}
          options={cartsList?.data.map((list) => ({
            value: list.id,
            label: _t(list.name, list.name),            
            disabled: !isCartAvailable(list),
          }))}
          onChange={handleChange}
          placeholder={"0"}
          // disabled={mode === "view"}
        />
      </Col>
      <Col lg={6}>
        {shouldSelectType ? (
          <SelectBox
            label={_t("type", "Type")}
            type="text"
            name="type"
            value={formData.type}
            options={[
              { value: "cheeks", label: _t("type_cheeks", "Cheeks") },
              { value: "strips", label: _t("type_strips", "Strips") },
              { value: "cheeks/strips", label: _t("type_cheeks_strips", "Cheeks/Strips") },
              { value: "tapita", label: _t("type_tapita", "Tapita") },
              { value: "cheeks/tapita", label: _t("type_cheeks_tapita", "Cheeks/Tapita") },
            ]}
            onChange={handleChange}
          />
        ) : (
          <InputWithLabel
            label={_t("type", "Type")}
            type="text"
            name="type"
            value={formData.type}
            onChange={handleChange}
            disabled={true}
          />
        )}
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("form_treys_count", "Treys Count")}
          type="number"
          name="treys_count"
          value={formData.treys_count}
          onChange={handleChange}
          disabled={mode === "edit"}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("form_time_end", "Time End")}
          type="datetime-local"
          name="time_end"
          value={formData.time_end}
          onChange={handleChange}
          disabled={mode === "edit"}
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("form_status", "Status")}
          type="text"
          name="status"
          value={formData?.status}
          options={[
            { value: "hydrating", label: _t("status_hydrating", "Hydrating") },
            { value: "cart_unloaded", label: _t("status_cart_unloaded", "Cart Unloaded")},
          ]}
          onChange={handleChange}
        />
      </Col>
      {formData.status === "cart_unloaded" && (formData.type === "cheeks" || formData.type === "cheeks/strips" || formData.type === "cheeks/tapita") && (
        <Col lg={6}>
          <InputWithLabel
            label={_t("cheeks_kg_bagged", "Cheeks Kg Bagged")}
            type="number"
            name="cheeks_kg_bagged"
            value={formData.cheeks_kg_bagged}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
      )}
      {formData.status === "cart_unloaded" && (formData.type === "strips" || formData.type === "cheeks/strips") && (
        <Col lg={6}>
          <InputWithLabel
            label={_t("strips_kg_bagged", "Strips Kg Bagged")}
            type="number"
            name="strips_kg_bagged"
            value={formData.strips_kg_bagged}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
      )}
      {formData.status === "cart_unloaded" && (formData.type === "tapita" || formData.type === "cheeks/tapita") && (
        <Col lg={6}>
          <InputWithLabel
            label={_t("tapita_kg_bagged", "Tapita Kg Bagged")}
            type="number"
            name="tapita_kg_bagged"
            value={formData.tapita_kg_bagged}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
      )}
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("modal_title_add_toasted_data", "Adding Toasted Data")}
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("button_save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            // isLoading={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default MoistureRoomModal;
